module.exports = __webpack_public_path__ + "static/media/1.98d7804f.jpg";